import script from "./index.vue?vue&type=script&lang=ts&setup=true&name=HPagination"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&name=HPagination"

import "./index.vue?vue&type=style&index=0&id=6640d765&lang=scss"

const __exports__ = script;

export default __exports__